export const sources={};export const img={src:"__VITE_ASSET__VRAku6fjghkApIISiBWPzg__",w:640,h:640};export default{sources:sources,img:img};